export const APP_VERSION = 'v 7.0.0';
